var _defs, _path, _path2, _path3, _path4, _a, _a2, _a3, _a4, _a5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 707.4 194.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #07b1b5;\n      }\n\n      .st1 {\n        fill: #8cc649;\n      }\n\n      .st2 {\n        fill: #14467a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo",
    className: "st2",
    d: "M63.1,7.2c37.3,0,55.9,21.5,55.9,47.5s-10.4,37.9-35.3,44.6l37.1,62.8h-35.9l-34.2-60.4h-14.6v60.4H5V7.2h58.1ZM62,33h-26v45.5h26c17.3,0,25.1-9.1,25.1-23.1s-7.8-22.4-25.1-22.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-2",
    className: "st2",
    d: "M182.7,37.2c19.7,0,33.3,9.3,40.6,19.5v-17.5h31.3v122.9h-31.3v-18c-7.3,10.6-21.3,20-40.8,20-31.1,0-55.9-25.5-55.9-63.9s24.8-63,56.1-63ZM190.7,64.5c-16.6,0-32.4,12.4-32.4,35.7s15.8,36.6,32.4,36.6,32.6-12.9,32.6-36.2-15.5-36.2-32.6-36.2h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-3",
    className: "st2",
    d: "M277.2,64.7h-14.6v-25.5h14.6V8.8h31.3v30.4h27.5v25.5h-27.5v59.5c0,8.2,3.3,11.8,13.1,11.8h14.4v26.2h-19.5c-23.5,0-39.3-10-39.3-38.2v-59.2h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-4",
    className: "st2",
    d: "M399.5,164.1c-35.7,0-61.7-24.9-61.7-63.5s25.3-63.5,61.7-63.5,60.6,24.2,60.6,60.8-.2,8-.9,12h-89.9c1.6,18.2,14,28.4,29.5,28.4s20.6-6.7,24.6-14.9h33.5c-6.7,22.6-27.1,40.6-57.5,40.6h0ZM369.5,89.1h58.4c-.4-16.2-13.3-26.4-29.3-26.4s-26.6,9.5-29.1,26.4h0Z"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    xlinkHref: 76.0870588235294
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "fullLogo-5",
    className: "st2",
    points: "484.2 40.1 484.2 163 535.3 163 535.3 97 522.8 83 484.2 40.1"
  }))), _a2 || (_a2 = /*#__PURE__*/React.createElement("a", {
    xlinkHref: 34.5117647058824
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "fullLogo-6",
    className: "st1",
    points: "527 9.6 489.6 9.6 527 51.3 527 9.6"
  }))), _a3 || (_a3 = /*#__PURE__*/React.createElement("a", {
    xlinkHref: 50.8886274509804
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "fullLogo-7",
    className: "st0",
    points: "479.2 11.3 530.3 68.2 530.3 78.1 479.2 21.2 479.2 13.1"
  }))), _a4 || (_a4 = /*#__PURE__*/React.createElement("a", {
    xlinkHref: 76.0870588235294
  }, /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-8",
    className: "st2",
    d: "M648.4,128.6c-7.3,4.7-16.1,7.3-26.1,7.3-28.2,0-47.5-20.2-47.5-51.7s19.3-51.3,47.5-51.3,47.3,19.7,47.3,51.3-5.7,30.9-15.4,39.9l19.5,21.7c17.1-14.2,27.9-35.7,27.9-61.6,0-46.4-35.1-79.2-79.2-79.2s-79.4,32.8-79.4,79.2,35.7,79.4,79.4,79.4,13.8-.9,20-2.4l23.5,28.2h36.6l-54-60.8h0Z"
  }))), _a5 || (_a5 = /*#__PURE__*/React.createElement("a", {
    xlinkHref: 34.5117647058824
  }, /*#__PURE__*/React.createElement("path", {
    id: "fullLogo-9",
    className: "st1",
    d: "M656.6,70.6c-5.7-18-24.4-28.1-41.7-22.6-7.9,2.5-14.1,7.8-18,14.5.3-.2.5-.3.8-.4,5.4-3.9,12.1-6.3,19.3-6.3,18.2,0,32.9,14.7,32.9,32.9s-3,15.7-7.9,21.4c0,0,0,.1,0,.2,13.2-7.6,19.7-24.1,14.8-39.7h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2f0691dc67779dead75a444c7db99562.svg";
export { ForwardRef as ReactComponent };